import React from 'react'
import cn from 'classnames'
import Breadcrumbs, {
  BreadcrumbsProps
} from 'core/components/navigation/Breadcrumbs'

interface Props {
  title: React.ReactNode
  subtitle?: React.ReactNode
  actions?: React.ReactNode
  children: React.ReactNode
  className?: string
  colSpanRule?: string
  crumbs?: BreadcrumbsProps['crumbs']
  backProps?: BreadcrumbsProps['backProps']
}

const PageWrapper = ({
  title,
  subtitle = null,
  children,
  actions = null,
  className = '',
  colSpanRule = 'col-span-12 xxl:col-span-10 xxl:col-start-2',
  crumbs,
  backProps
}: Props) => {
  return (
    <section className={className}>
      {crumbs?.length && (
        <div className="grid grid-cols-12 mb-1">
          <div className={colSpanRule}>
            <Breadcrumbs
              crumbs={crumbs}
              backProps={backProps}
              classname="mb-5"
            />
          </div>
        </div>
      )}
      <div className="grid grid-cols-12 my-3">
        <div
          className={cn(
            colSpanRule,
            'flex flex-col md:flex-row md:justify-between md:items-center'
          )}
        >
          <h1 className="heading">{title}</h1>
          {actions}
        </div>
      </div>
      {subtitle && (
        <div className="grid grid-cols-12 mb-5">
          <div className={colSpanRule}>{subtitle}</div>
        </div>
      )}
      <div className="grid grid-cols-12 mb-24">
        <div className={colSpanRule}>{children}</div>
      </div>
    </section>
  )
}

export default PageWrapper
